import { SxProps, Theme } from '@mui/material';

export const tileDescriptionSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'normal',
	opacity: 1,
};

export const linkTitleSX: SxProps<Theme> = {
	// wordBreak: 'break-word',
	fontSize: 'var(--font-size-sm)',
	letterSpacing: '0px',
	color: '#2682E7',
	fontWeight: 'normal',
	opacity: 1,
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'none',
	},
};
